module.exports = __webpack_public_path__ + "img/WeChat-Official-Account-Interface.7cbb2b34.png";